export default __webpack_public_path__ + "static/red-confetti-690b5895df851d26641530690368d027.png";